<template>
  <v-card class="crud-card">
    <v-card-title class="crud-card-title">
      <h2 class="text-h5">Check this is the right document</h2>
      <v-spacer />
      <v-icon class="modal-close" color="black" @click.stop="$emit('cancel')">{{
        icons.mdiClose
      }}</v-icon>
    </v-card-title>
    <v-divider />
    <v-card-text class="crud-card-text">
      <p class="mismatch-warning">
        <v-icon color="warning" class="mr-2">{{
          icons.mdiAlertCircleOutline
        }}</v-icon>
        <span>{{ message }}</span>
      </p>
      <p class="mismatch-prompt">{{ prompt }}</p>
    </v-card-text>
    <v-card-actions class="crud-card-actions">
      <v-spacer />
      <div class="button-container">
        <DefaultButton
          :title="'Choose a different file'"
          :small="true"
          @defaultButtonClicked="$emit('cancel')"
        />
        <GradientButton
          :title="'Upload anyway'"
          :small="true"
          :callout="'right'"
          :loading="loading"
          @gradientButtonClicked="$emit('confirm')"
        />
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
  // `icons` comes from the global mixin registered in src/constants/js/global-mixin.js.
  export default {
    name: 'WillIdentityMismatchDialog',
    props: {
      message: {
        required: true,
        type: String,
      },
      prompt: {
        type: String,
        default: 'Are you sure you want to upload this document?',
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mismatch-warning {
    display: flex;
    align-items: flex-start;
    font-weight: 600;
  }

  .mismatch-prompt {
    margin-top: 12px;
  }

  .button-container {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 22px;
  }
</style>
